<div class="smart-list">
  <div class="smart-list__header">
    <i class="pi smart-list__header-icon" [class]="headerIcon()" aria-hidden="true"></i>
    <span class="smart-list__header-name">{{ headerLabelKey() | translate }}</span>
    <span class="smart-list__header-count">{{ rows().length }}</span>
  </div>
  <div class="smart-list__body">
    @if (isLoading() && !hasItems()) {
      <div class="smart-list__loading">
        <p-progressSpinner styleClass="smart-list__spinner" strokeWidth="3" />
      </div>
    } @else if (hasError() && !hasItems()) {
      <div class="smart-list__error">
        <span>{{ 'DOCUMENT_MANAGEMENT.LOAD_ERROR' | translate }}</span>
        <p-button
          icon="pi pi-refresh"
          [text]="true"
          size="small"
          [label]="'GENERAL.RETRY' | translate"
          (onClick)="reload()" />
      </div>
    } @else if (!hasItems()) {
      <div class="smart-list__empty">
        <span>{{ emptyKey() | translate }}</span>
      </div>
    } @else {
      <ul class="smart-list__list" role="listbox" [attr.aria-label]="headerLabelKey() | translate">
        @for (row of rows(); track row.key) {
          @if (row.kind === 'folder' && row.folder; as folder) {
            <li
              class="smart-list__row smart-list__row--folder"
              [class.smart-list__row--selected]="folder.id === selectedChildId()"
              role="option"
              tabindex="0"
              [attr.aria-selected]="folder.id === selectedChildId()"
              (click)="onSelectFolder(folder)"
              (keydown)="onSelectFolderKeydown($event, folder)">
              <i
                class="pi smart-list__icon"
                [class.pi-folder]="folder.kind !== 'managed_branch'"
                [class.pi-server]="folder.kind === 'managed_branch'"
                aria-hidden="true"></i>
              <span class="smart-list__name">{{ folder.displayName ?? folder.name }}</span>
              <i class="pi pi-chevron-right smart-list__chevron" aria-hidden="true"></i>
              @if (showTags() && folder.tags.length > 0) {
                <tf-tag-editor
                  class="smart-list__row-tags"
                  [tags]="folder.tags"
                  [editable]="false" />
              }
            </li>
          } @else if (row.kind === 'document' && row.document; as doc) {
            <li
              class="smart-list__row smart-list__row--document"
              [class.smart-list__row--selected]="doc.id === selectedDocumentId()"
              [class.smart-list__row--deleted]="doc.softDeletedAt !== undefined"
              role="option"
              tabindex="0"
              [attr.aria-selected]="doc.id === selectedDocumentId()"
              (click)="onSelectDocument(doc)"
              (keydown)="onSelectDocumentKeydown($event, doc)">
              <span
                class="smart-list__doc-thumb"
                [class]="mimeColorClassFor(doc.mimeType)"
                aria-hidden="true">
                {{ mimeShortLabel(doc.mimeType) }}
              </span>
              <span class="smart-list__doc-meta">
                <span class="smart-list__doc-name" [title]="doc.name">{{ doc.name }}</span>
                @if (doc.size !== undefined) {
                  <span class="smart-list__doc-sub">
                    {{ formatSize(doc.size) }}
                  </span>
                }
              </span>
              @if (doc.softDeletedAt !== undefined) {
                <span
                  class="smart-list__deleted-pill"
                  [pTooltip]="'DOCUMENT_MANAGEMENT.DELETED_HINT' | translate">
                  {{ 'DOCUMENT_MANAGEMENT.DELETED_PILL' | translate }}
                </span>
              }
              @if (showTags() && doc.tags.length > 0) {
                <tf-tag-editor class="smart-list__row-tags" [tags]="doc.tags" [editable]="false" />
              }
            </li>
          }
        }
      </ul>
    }
  </div>
</div>
